import React from "react";

// Flat matte lottery ball
export const Ball = ({ n, special, color, size = "md", delay = 0, animate = false }) => {
  const sizes = {
    sm: "w-8 h-8 text-xs",
    md: "w-11 h-11 text-sm",
    lg: "w-14 h-14 text-base",
  };
  const base = `${sizes[size]} flex items-center justify-center rounded-full font-mono font-bold shrink-0 transition-transform duration-200`;
  const style = special
    ? { backgroundColor: color, color: "#09090b", borderColor: color }
    : {};
  const cls = special
    ? `${base} border`
    : `${base} bg-zinc-800 text-zinc-50 border border-zinc-700`;

  const content = (
    <div className={cls} style={style} data-testid={`ball-${special ? "special-" : ""}${n}`}>
      {String(n).padStart(2, "0")}
    </div>
  );

  if (!animate) return content;
  return (
    <div
      style={{ animation: `pop 0.4s ease-out ${delay}s both` }}
      className="inline-block"
    >
      {content}
      <style>{`@keyframes pop{0%{opacity:0;transform:scale(0.3) translateY(8px)}70%{transform:scale(1.12)}100%{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
};

export const heatColor = (heat) => {
  // heat 0..1 -> cold cyan to hot red
  if (heat >= 0.85) return "#FF3B30";
  if (heat >= 0.65) return "#FF9500";
  if (heat >= 0.45) return "#FBBF24";
  if (heat >= 0.25) return "#3B82F6";
  if (heat > 0) return "#0891b2";
  return "#27272a";
};
